import Vue from 'vue'
import Vuex from 'vuex'
import router from './../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    completeUserData: {},
  },

  mutations: {
    loginUser(state, item) {
      state.isLoggedIn = true
      state.completeUserData = item
    },

    userData(state, payload) {
      state.completeUserData = payload
    },
    logoutUser(state) {
      state.isLoggedIn = false
      localStorage.removeItem("token");
      localStorage.removeItem("shopid");
      localStorage.removeItem("userType");
      router.push('/Login')
    }

  }
})
